var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"tw-gray-100"},[_c('default-header',{attrs:{"left-clip":""}}),_c('v-main',{staticClass:"tw-min-h-screen"},[_c('app-drawer-main'),_vm._t("default",function(){return [_c('v-fade-transition',[_c('router-view')],1)]}),_c('default-footer')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }